export default "__VITE_ASSET__BxbgBFmU__"